<template>
  <div>
    <UserNavbar />
    <router-view />
    <UserFooter />
  </div>
</template>

<script setup lang="ts">
import UserNavbar from "@/components/UserNavbar.vue";
import UserFooter from "@/components/UserFooter.vue";
import { useRouter } from "vue-router";
import { USER_ROUTES } from "@/assets/route_constants";
const router = useRouter();
router.push({ name: USER_ROUTES.Home.Name });
</script>
